export default "__VITE_ASSET__$VQWg0XT__"